import React, { type FunctionComponent, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  type OrdersListApiOrderCounts,
  type OrdersListApiApproxGMV,
} from 'legacy/sections/orders/components/list/utils/ordersList.types'
import { type OrderStatus } from 'legacy/sections/orders/utils/orders.types'
import { OrdersListTabItemDetails } from 'legacy/sections/orders/components/list/components/tabs/components/OrdersListTabItemDetails'
import { SubNavItemContent } from 'legacy/components/Nav/SubNavItemContent'

interface Props {
  loading: boolean
  isActive: boolean
  orderCounts?: OrdersListApiOrderCounts
  approxGmv?: OrdersListApiApproxGMV
  orderStatus: OrderStatus
  setOrderStatus: (nextOrderStatus: OrderStatus) => void
}

export const OrdersListTabsItem: FunctionComponent<Props> = ({
  loading,
  isActive,
  approxGmv,
  orderCounts,
  orderStatus,
  setOrderStatus,
}) => {
  const tabMessageId = `orders.${orderStatus || 'all'}`

  const renderedDetails = (
    <OrdersListTabItemDetails loading={loading} approxGmv={approxGmv} orderStatus={orderStatus} />
  )

  const setTabOrderStatus = useCallback(
    () => setOrderStatus(orderStatus),
    [orderStatus, setOrderStatus]
  )

  return (
    <SubNavItemContent
      isActive={isActive}
      details={renderedDetails}
      onClick={setTabOrderStatus}
      id={tabMessageId}
    >
      <FormattedMessage id={tabMessageId} />
      {!loading && orderCounts && (
        <FormattedMessage id="orders.count" values={{ count: orderCounts[orderStatus || 'all'] }} />
      )}
    </SubNavItemContent>
  )
}
